import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";

// ── DBS Checks ──────────────────────────────────────────────────────────────

export interface IDbsCheck {
  id: number;
  company_id: number;
  user_id: number;
  check_level: "basic" | "standard" | "enhanced" | "enhanced_barred";
  certificate_number: string | null;
  issue_date: string | null;
  expiry_date: string | null;
  status: "pending" | "clear" | "has_information";
  document_url: string | null;
  notes: string | null;
  created_at: string;
  worker_name?: string | null;
}

export interface IDbsCreatePayload {
  user_id: number;
  check_level: string;
  certificate_number?: string;
  issue_date?: string;
  expiry_date?: string;
  status?: string;
  document_url?: string;
  notes?: string;
}

// ── Right to Work ────────────────────────────────────────────────────────────

export interface IRtwCheck {
  id: number;
  company_id: number;
  user_id: number;
  check_date: string;
  document_type: "passport" | "brp" | "share_code" | "birth_cert_ni" | "eu_settlement";
  document_number: string | null;
  expiry_date: string | null;
  status: "pending" | "pass" | "fail";
  share_code: string | null;
  follow_up_date: string | null;
  notes: string | null;
  created_at: string;
  worker_name?: string | null;
}

export interface IRtwCreatePayload {
  user_id: number;
  document_type: string;
  check_date?: string;
  document_number?: string;
  expiry_date?: string;
  status?: string;
  share_code?: string;
  follow_up_date?: string;
  notes?: string;
}

export async function listDbsChecks(qData: QData): Promise<AxiosResponse<TResponseWithQData<IDbsCheck[]>>> {
  return axios.get(API_ENDPOINTS.DBS_LIST, { params: qData });
}

export async function createDbsCheck(data: IDbsCreatePayload): Promise<AxiosResponse<TResponse<IDbsCheck>>> {
  return axios.post(API_ENDPOINTS.DBS_CREATE, data);
}

export async function updateDbsCheck(data: IDbsCreatePayload & { id: number }): Promise<AxiosResponse<TResponse<IDbsCheck>>> {
  return axios.put(`${API_ENDPOINTS.DBS_UPDATE}/${data.id}`, data);
}

export async function deleteDbsCheck(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete(`${API_ENDPOINTS.DBS_DELETE}/${id}`);
}

export async function listRtwChecks(qData: QData): Promise<AxiosResponse<TResponseWithQData<IRtwCheck[]>>> {
  return axios.get(API_ENDPOINTS.RTW_LIST, { params: qData });
}

export async function createRtwCheck(data: IRtwCreatePayload): Promise<AxiosResponse<TResponse<IRtwCheck>>> {
  return axios.post(API_ENDPOINTS.RTW_CREATE, data);
}

export async function updateRtwCheck(data: IRtwCreatePayload & { id: number }): Promise<AxiosResponse<TResponse<IRtwCheck>>> {
  return axios.put(`${API_ENDPOINTS.RTW_UPDATE}/${data.id}`, data);
}

export async function deleteRtwCheck(id: number): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete(`${API_ENDPOINTS.RTW_DELETE}/${id}`);
}
